module.exports = __webpack_public_path__ + "static/media/bokica.bf3f4b96.png";